// let loadingCount = 0;

export const apiFetch = async (url, options = {}) => {
  try {
    // loadingCount += 1;
    // if (loadingCount === 1) {
    //   document.getElementById("tmoverlay").className = "tmoverlay d-block";
    // }

    let response = await fetch(url, options);

    if (!response.ok) {
      console.error(`Error: ${response.statusText}`);
    }

    return await response;
  } catch (error) {
    console.error(error);
  } finally {
    // loadingCount -= 1;
    // if (loadingCount === 0) {
    //   document.getElementById("tmoverlay").className = "d-none";
    // }
  }
};
